import type { ConversationItemHoverIconsProps } from './index.types';
import { ChatDetailsButton } from 'Components/ActivityItemPhoneVideoButtons/ChatDetailsButton';
import { observer } from 'mobx-react';
import { useIsPersonInactive } from 'Modules/conversation/hooks/useIsPersonInactive';
import * as React from 'react';
import { cn } from '~/lib/utils';
import { useOpenChatDetails } from '../hooks/useOpenChatDetails';
import ConversationItemCallButtons from './ConversationItemCallButtons';
import ConversationItemMoreActions from './ConversationItemMoreActions';

const ConversationItemHoverIcons: React.FC<ConversationItemHoverIconsProps> =
  observer(({ conversation, className, onPopoverContentHoverChange }) => {
    const openChatDetails = useOpenChatDetails(conversation);

    const isInactive = useIsPersonInactive(conversation);

    return (
      <div className={cn('flex items-center', className)}>
        {!isInactive && (
          <div className="hidden group-hover:flex items-center">
            <ChatDetailsButton
              isGroupChat={conversation.grouping !== 'OneOnOne'}
              compact
              onClick={openChatDetails}
              {...{
                size: 'small',
                popupPosition: 'bottom right',
                testid: 'conversationItem',
              }}
            />

            <ConversationItemCallButtons conversation={conversation} />
          </div>
        )}

        <ConversationItemMoreActions
          conversation={conversation}
          onPopoverContentHoverChange={onPopoverContentHoverChange}
        />
      </div>
    );
  });

export default ConversationItemHoverIcons;
